import { api } from "../axios";
import { cloudFlareInitialConfigURL, initialConfigApi } from "../endpoints";

const getInitialConfig = async () => {
  const url = new URL(`${cloudFlareInitialConfigURL}${initialConfigApi}`);
  return api
    .get(url)
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch(() => {
      console.warn("Erro ao buscar configuração inicial do Cloudflare...");
    });
};

export { getInitialConfig };
